const form = {
  formId: "new-user-form",
  formField: {
    separateDeclaration: {
      name: "separateDeclaration",
      label: "Khai báo riêng đối với khoản thu hộ do cơ qua nhà nước có thẩm quyền giao",
      type: "text",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId: {
      name: "taxId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "[06] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[07] Mã số thuế đại lý:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    contractNumber: {
      name: "contractNumber",
      label: "[08] Hợp đồng đại lý thuế: Số:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số hợp đồng đại lý thuế",
      invalidMsg: "Mã số hợp đồng đại lý thuế không hợp lệ",
    },
    contractDay: {
      name: "contractDay",
      label: "Ngày:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn ngày hợp đồng tính thuế",
    },
    dependentUnitName: {
      name: "dependentUnitName",
      label:
        "[09] Tên đơn vị phụ thuộc/địa điểm kinh doanh của hoạt động sản xuất kinh doanh khác tỉnh nơi đóng trụ sở chính:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị phụ thuộc/địa điểm kinh doanh",
    },
    dependentUnitNameTaxId: {
      name: "dependentUnitNameTaxId",
      label: "[10] Mã số thuế đơn vị phụ thuộc/Mã số địa điểm kinh doanh:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đơn vị phụ thuộc/Mã số địa điểm kinh doanh",
      invalidMsg: "Mã số thuế/mã số địa điểm không hợp lệ",
    },
    activeAddress: {
      name: "activeAddress",
      label: "[11] Địa chỉ nơi có hoạt động sản xuất kinh doanh khác tỉnh nơi đóng trụ sở chính:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ sản xuất kinh doanh",
    },
    addressCity: {
      name: "addressCity",
      label: "[11c] Tỉnh/Thành phố:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Tỉnh/Thành phố",
    },
    addressDistrict: {
      name: "addressDistrict",
      label: "[11b] Quận/Huyện:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Quận/Huyện",
    },
    addressWard: {
      name: "addressWard",
      label: "[11a] Phường/Xã:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập Phường/Xã",
    },
    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
